export default {
  Shown: 'Shown',
  Hide: 'Hidden'
}
